import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItemAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { IOrcamento } from "app/types/IOrcamento"
import {CriaOrcamentoAposTotalizador} from "../../utils/CriaOrcamentoAposTotalizador";
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'



declare var window:any

export type DefinirPercentualDescontoInput = {
    percentualDesconto: number
}

export async function definirPercentualDesconto(input: DefinirPercentualDescontoInput) {

    const orcamentoAtualizado = await microuniversoApi.Orcamento.DefinirPercentualDesconto(
        store.getState().orcamento.IdentificadorOrcamento,
        input.percentualDesconto
    )

    const atualizarEstado = () => {
        const orcamentoLegado = window.orcamentoController.model

        orcamentoLegado.atualizar(orcamentoAtualizado, true, true)

        store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
    }


    atualizarEstado()
}
